import script from "./VehicleSelectorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleSelectorModal.vue?vue&type=script&setup=true&lang=js"

import "./VehicleSelectorModal.vue?vue&type=style&index=0&id=08d5caf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d5caf6"]])

export default __exports__